export default __webpack_public_path__ + "static/map-outline-75b55a86e542370200d894f197a54e7d.png";